//********* SQFT *********//
import * as types from "./actionTypes";

export const toggleShowManualCalculation = (showManualCalculation) => ({
  type: types.TOGGLE_SHOW_MANUAL_CALCULATION,
  payload: {showManualCalculation}
});

export const setSwitcherPosition = (switcherPosition) => ({
  type: types.SET_SWITCHER_POSITION,
  payload: {switcherPosition}
});

export const addManualCalculateRow = (type) => ({
  type: types.ADD_MANUAL_CALCULATION_ROW,
  payload: {type}
});

export const updateManualCalculateRow = (type, row, updatedRowValue) => ({
  type: types.UPDATE_MANUAL_CALCULATION_ROW,
  payload: {type, row, updatedRowValue}
});

export const updateManualCalculateRows = (manualCalculationRows) => ({
  type: types.UPDATE_MANUAL_CALCULATION_ROWS,
  payload: manualCalculationRows
});

export const deleteManualCalculateRow = (type, id) => ({
  type: types.DELETE_MANUAL_CALCULATION_ROW,
  payload: {type, id}
});
